var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.14 299.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 10996.96,
    y1: -889.77,
    x2: 11091.99,
    y2: -889.77,
    gradientTransform: "translate(-792.21 -10841.18) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af96f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7185e7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-2",
    x1: -2137.71,
    y1: 9604.17,
    x2: -2083.72,
    y2: 9604.17,
    gradientTransform: "translate(9469.01 -2641.15) rotate(60.95)",
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M21.94,150.5c-5.47,26.21,18.69,45.71,64.14,51.77,47.02,6.26,65.88-13.98,138.48,4.3,57.89,14.58,88.41-10.85,98.91-27.63,5.02-8.02,18.31-30.69-20.69-45.17-59.98-22.28-54.27-62.17-119-70.79-64.73-8.62-127.7-5.59-130.69,28.85-2.95,34.1-25.98,33.91-31.15,58.67Z",
    style: {
      fill: "#d7cfff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.55,
    cy: 203.29,
    r: 47.51,
    style: {
      fill: "url(#Degradado_sin_nombre_3)",
      filter: "url(#drop-shadow-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,212.26c-1.28-.31-2.18-.98-2.71-1.99-.53-1.02-.63-2.21-.29-3.59.47-1.92,1.28-3.63,2.43-5.15,1.15-1.51,2.84-2.96,5.05-4.35,1.48-.94,2.56-1.77,3.23-2.49.67-.72,1.12-1.55,1.35-2.48.57-2.31-.77-3.86-4.02-4.66-1.57-.39-3.09-.57-4.55-.57-1.46,0-2.91.2-4.36.57-1.66.38-3.02.3-4.09-.22-1.07-.52-1.82-1.31-2.24-2.35-.42-1.04-.51-2.16-.27-3.35.24-1.19.83-2.27,1.77-3.24.94-.97,2.29-1.63,4.04-1.98,2.26-.49,4.57-.69,6.95-.6,2.37.09,4.55.37,6.51.86,3.39.83,6.24,2.11,8.56,3.82,2.31,1.71,3.94,3.73,4.89,6.04.94,2.32,1.1,4.75.47,7.31-.54,2.21-1.55,4.14-3.02,5.78-1.47,1.65-3.75,3.11-6.82,4.38-2.72,1.1-4.61,2.15-5.66,3.15-1.05.99-1.89,2.12-2.51,3.37-.39.74-.97,1.29-1.73,1.65-.77.36-1.76.39-2.99.09ZM90.7,229.82c-2.26-.55-3.88-1.67-4.85-3.34-.97-1.67-1.2-3.56-.68-5.68s1.57-3.6,3.2-4.61c1.63-1.01,3.57-1.23,5.83-.68,2.26.55,3.87,1.65,4.82,3.29.95,1.64,1.18,3.49.67,5.56s-1.58,3.69-3.19,4.73c-1.61,1.04-3.54,1.28-5.8.73Z",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.09,
    cy: 176.9,
    r: 26.99,
    style: {
      fill: "url(#Degradado_sin_nombre_3-2)",
      filter: "url(#drop-shadow-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.42,181.99c-.72.2-1.35.12-1.9-.24-.54-.36-.92-.92-1.13-1.7-.3-1.08-.37-2.16-.21-3.23.15-1.07.59-2.25,1.31-3.55.48-.87.78-1.58.92-2.13.13-.54.13-1.08-.01-1.61-.36-1.3-1.45-1.71-3.28-1.21-.89.24-1.69.57-2.42.97-.72.41-1.39.9-2.01,1.49-.72.64-1.42.98-2.09,1.02-.68.04-1.26-.15-1.76-.55-.5-.4-.85-.93-1.06-1.59-.21-.66-.21-1.36-.01-2.1.2-.74.69-1.44,1.46-2.1.99-.86,2.08-1.6,3.28-2.21,1.2-.61,2.36-1.07,3.47-1.37,1.91-.52,3.68-.68,5.3-.46,1.62.21,2.99.76,4.09,1.65,1.11.89,1.86,2.06,2.25,3.5.34,1.25.37,2.48.1,3.71-.28,1.22-1,2.58-2.18,4.06-1.05,1.3-1.69,2.34-1.94,3.12-.25.78-.35,1.57-.32,2.37.01.47-.13.91-.41,1.3-.28.39-.77.68-1.46.87ZM52,191.97c-1.28.35-2.39.24-3.33-.32-.94-.56-1.58-1.44-1.9-2.63s-.21-2.22.32-3.17c.53-.95,1.43-1.6,2.71-1.95,1.28-.35,2.38-.25,3.3.31.93.55,1.55,1.41,1.86,2.58.33,1.19.23,2.27-.28,3.23-.51.96-1.41,1.61-2.68,1.96Z",
    style: {
      fill: "#f1f2f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.99,
    y: 30.36,
    width: 129.74,
    height: 239.73,
    rx: 7.36,
    ry: 7.36,
    transform: "translate(-13.04 17.46) rotate(-5.28)",
    style: {
      fill: "#1d254f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.28,
    y: 29.87,
    width: 129.74,
    height: 239.73,
    rx: 7.36,
    ry: 7.36,
    transform: "translate(-12.98 17.94) rotate(-5.28)",
    style: {
      fill: "#9b80ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.2,
    y: 42.86,
    width: 108.56,
    height: 183.81,
    rx: 7.36,
    ry: 7.36,
    transform: "translate(-11.6 17.82) rotate(-5.28)",
    style: {
      fill: "#f0eeff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.82,
    cy: 250.94,
    r: 12.72,
    style: {
      fill: "#8058f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85,167.43h-170.46l-20.82,13.56c-1.63,1.03-3.67-.51-3.14-2.36l4.67-20.77v-88.07c0-5.29,4.12-9.57,9.2-9.57h180.55c5.08,0,9.2,4.29,9.2,9.57v88.07c0,5.29-4.12,9.57-9.2,9.57Z",
    style: {
      fill: "#fff",
      filter: "url(#drop-shadow-4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.49,
    y: 84.8,
    width: 138.17,
    height: 7.29,
    rx: 3.65,
    ry: 3.65,
    style: {
      fill: "#e9e6ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.8,
    cy: 88.23,
    r: 10.3,
    style: {
      fill: "#e9e6ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.49,
    y: 108.83,
    width: 138.17,
    height: 7.29,
    rx: 3.65,
    ry: 3.65,
    style: {
      fill: "#e9e6ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.8,
    cy: 112.26,
    r: 10.3,
    style: {
      fill: "#e9e6ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.49,
    y: 132.86,
    width: 138.17,
    height: 7.29,
    rx: 3.65,
    ry: 3.65,
    style: {
      fill: "#d7d4ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.8,
    cy: 136.29,
    r: 10.3,
    style: {
      fill: "#d7d4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.31,77.39c.67.67.67,1.74,0,2.41l-13.62,13.62c-.67.67-1.74.67-2.41,0l-6.81-6.81c-.67-.67-.67-1.74,0-2.41s1.74-.67,2.41,0l5.61,5.6,12.42-12.41c.67-.67,1.74-.67,2.41,0h0Z",
    style: {
      fill: "#9b80ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.31,101.24c.67.67.67,1.74,0,2.41l-13.62,13.62c-.67.67-1.74.67-2.41,0l-6.81-6.81c-.67-.67-.67-1.74,0-2.41s1.74-.67,2.41,0l5.61,5.6,12.42-12.41c.67-.67,1.74-.67,2.41,0h0Z",
    style: {
      fill: "#9b80ff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.5c157a89f13a61ba5f000ec3b9248a90.svg";
export { ForwardRef as ReactComponent };